
import Body from './body'
import BottomContext from './bottom'
const TempleteSix = () => {
    return <>
        <Body></Body>
        <BottomContext></BottomContext>
    </>
}

export default TempleteSix